import { IAdvertRepository } from '../ports/IAdvertRepository';
import { AdvertEntity } from '../../domain/entities/Advert';

export class GetAdvertUseCase {
  constructor(private repo: IAdvertRepository) {}
  execute(uuid: string): Promise<AdvertEntity> { return this.repo.get(uuid); }
}
